export default {
  en: {
    HEADER_REAL_TIME_BIDDING: 'Real Time Bidding',
    HEADER_EXPORT_BIDS: 'Export Bids',
    HEADER_SEARCH_BIDS: 'Search Bids',
    INPUT_SEARCH_BIDS_PLACEHOLDER: 'Enter Bid ID',
    BUTTON_EXPORT_CSV: 'Export CSV',

    SEARCH_BY_BID_ID: 'Bid ID',
    SEARCH_BY_CALLER_ID: 'Caller ID',
    INPUT_SEARCH_CALLER_ID_PLACEHOLDER: 'Enter Caller ID',
    CALLER_ID_RESULT_COUNT: '{count} bids found for this caller.',
    CALLER_ID_RESULT_COUNT_PARTIAL: 'Showing the first 200 results — more bids may exist for this caller.',
    CALLER_ID_BID_RECORD_NOT_FOUND: 'No exposed bids found for this caller ID.',

    TAB_HEAD_BID_DETAILS: 'Bid Details',
    TAB_HEAD_BID_TRACE: 'Bid Trace',
    TAB_HEAD_BID_EVENTS: 'Events',
    TAB_HEAD_BID_RING_TREE_EVENTS: 'Ring Tree Events',
    TAB_HEAD_BID_TAGS: 'Tags',

    CELL_BID_STATUS: 'Bid Status',
    CELL_BID_ID: 'Bid ID',
    CELL_BID_TIMESTAMP: 'Timestamp',
    CELL_DT: 'Date/Time',
    CELL_WINNING_BID: 'Winning Bid',
    CELL_CAMPAIGN: 'Campaign',
    CELL_PUBLISHER: 'Publisher',
    CELL_BASELINE_BID: 'Baseline Bid',
    CELL_MAX_BID: 'Max Bid',
    CELL_MIN_DURATION_ADJUSTMENTS: 'Min Duration Adjustments',
    CELL_BASELINE_MIN_DURATION: 'Baseline Min Duration',
    CELL_FINAL_MIN_DURATION: 'Final Min Duration',
    CELL_FINAL_BID: 'Final Bid',
    CELL_BID: 'Bid',
    CELL_BID_BEFORE: 'Bid Before',
    CELL_BID_AFTER: 'Bid After',
    CELL_ADJUSTMENTS: 'Adjustments',
    CELL_ADJUSTMENT_TYPE: 'Adjustment Type',
    CELL_ADJUSTMENT_VALUE: 'Adjustment Value',
    CELL_MATCHED: 'Matched',
    CELL_REJECTED: 'Rejected',
    CELL_PUBLISHER_OVERRIDES: 'Publisher Overrides',

    BID_RECORD_NOT_FOUND: 'Bid record not found.',

    OVERRIDE_RATE_LIMIT_SETTINGS: 'Rate Limit',
    OVERRIDE_DEFAULT_BID_SETTINGS: 'Bid Settings',
    OVERRIDE_DEFAULT_PASS_THROUGH_SETTINGS: 'Pass Through Settings',
    OVERRIDE_BID_ADJUSTMENTS: 'Bid Adjustments',
    OVERRIDE_CALLER_ID_REQUIRED: 'Caller ID Required',
    OVERRIDE_BID_EXPIRATION_POLICY: 'Bid Expiration',
    OVERRIDE_MIN_DURATION_ADJUSTMENT: 'Min Duration Adjustment',
  }
};
